import { render, staticRenderFns } from "./OtpUserLoginHandler.vue?vue&type=template&id=ffa5542e"
import script from "./OtpUserLoginHandler.vue?vue&type=script&lang=ts"
export * from "./OtpUserLoginHandler.vue?vue&type=script&lang=ts"
import style0 from "./OtpUserLoginHandler.vue?vue&type=style&index=0&id=ffa5542e&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports